module.exports = __webpack_public_path__ + "img/7.73015f6d.png";